var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_45)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5349 1.01654C7.29896 1.34059 1.40694 7.05039 1.02058 14.1179C0.705609 19.918 4.03588 24.992 8.9788 27.3505C10.8224 28.2283 13.0146 27.125 13.3673 25.1519C13.6068 23.823 12.9138 22.5062 11.6749 21.9155C8.86541 20.5701 6.97979 17.6619 7.20238 14.3517C7.46275 10.4795 10.6712 7.33341 14.6356 7.06679C19.3224 6.75095 23.228 10.3729 23.228 14.8808C23.228 17.9777 21.3885 20.6522 18.7176 21.9238C17.4997 22.5062 16.8321 23.8147 17.0672 25.1191L17.0798 25.1847C17.4284 27.125 19.5827 28.2283 21.3928 27.371C26.1383 25.1273 29.414 20.3774 29.414 14.8808C29.414 6.99706 22.6863 0.647375 14.5349 1.01654Z",
    fill: "#EE2938"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2193 19.7618C12.4601 19.7618 10.2176 17.5714 10.2176 14.8766C10.2176 12.1816 12.4601 9.99121 15.2193 9.99121C17.9784 9.99121 20.221 12.1816 20.221 14.8766C20.221 17.5714 17.9784 19.7618 15.2193 19.7618Z",
    fill: "#EE2938"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRed);
export default __webpack_public_path__ + "static/media/icon_red.4e83ecab853f623d3861fd9dbd545eaf.svg";
export { ForwardRef as ReactComponent };